import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container frame" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "8",
  r: "8"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "panels" }
const _hoisted_8 = { class: "messages" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "timestamp" }
const _hoisted_11 = { class: "subject" }
const _hoisted_12 = { class: "recipient" }
const _hoisted_13 = { class: "timestamp" }
const _hoisted_14 = { class: "sender" }
const _hoisted_15 = { class: "recipient" }
const _hoisted_16 = { class: "timestamp" }
const _hoisted_17 = { class: "mailEventType" }
const _hoisted_18 = { class: "sourceId" }
const _hoisted_19 = { class: "preview" }
const _hoisted_20 = {
  key: 2,
  class: "emptySelection"
}

import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { DateTime } from 'luxon';
import { WebSocketMessageAPIModel, CommunicationAPIModel, MessageType, CommunicationType, MailEventAPIModel, MailEventType } from '@/model/APIModel';
import { WebSocketMessageViewModel, CommunicationViewModel, MailEventViewModel } from '@/model/ViewModel';
import EmailPreview from '@/components/EmailPreview.vue';
import SMSPreview from '@/components/SMSPreview.vue';
import WebSocketClient from 'js-websocket-reconnect-client';



export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const MaxMessagesCount = 25;


const { t } = useI18n();
const messages = ref<WebSocketMessageViewModel[]>([]);
const selected = ref<WebSocketMessageViewModel>();

const isEmptySelection = computed<boolean>(() =>
{
  return !selected.value;
});

function isEmail(message: WebSocketMessageViewModel | undefined)
{
  if (!message || message.MessageType !== MessageType.Communication)
    return false;

  const communication = <CommunicationViewModel>message;
  return communication.CommunicationType === CommunicationType.Email || communication.CommunicationType === CommunicationType.SystemEmail;
}

function isSMS(message: WebSocketMessageViewModel | undefined)
{
  if (!message || message.MessageType !== MessageType.Communication)
    return false;

  const communication = <CommunicationViewModel>message;
  return communication.CommunicationType === CommunicationType.SMS;  
}

function isMailEvent(message: WebSocketMessageViewModel | undefined)
{
  console.log(message.MessageType);
  return !!message && message.MessageType === MessageType.MailEvent;
}


onMounted(() =>
{
  connectWebsocket();
});


onUnmounted(() =>
{
  disconnectWebsocket();
})


let websocket: WebSocketClient | undefined = undefined;
const websocketConnected = ref<boolean>(false);


function connectWebsocket()
{
  const url = (window.location.protocol === 'https:' ? 'wss://' : 'ws://') +
              window.location.host + '/v1/listen';

  websocket = new WebSocketClient(url);
  websocket.addOnMessageHandler(onWebsocketMessage);
  websocket.addOnOpenHandler(() => websocketConnected.value = true);
  websocket.addOnCloseHandler(() => websocketConnected.value = false);
  websocket.connect();
}


function disconnectWebsocket()
{
  websocket?.close();
  websocket = undefined;
}


let messageKey = 0;

function onWebsocketMessage(message: WebSocketMessageAPIModel)
{
  messageKey++;

  let viewModel: WebSocketMessageViewModel | undefined = undefined;

  switch (MessageType[message.MessageType as keyof typeof MessageType])
  {
    case MessageType.Communication:
      viewModel = getCommunicationViewModel(message as CommunicationAPIModel);
      break;

    case MessageType.MailEvent:
    viewModel = getMailEventViewModel(message as MailEventAPIModel);
      break;
  }
  

  if (!!viewModel)
  {
    messages.value.unshift(viewModel);
    if (messages.value.length >= MaxMessagesCount)
      messages.value.splice(MaxMessagesCount, messages.value.length - MaxMessagesCount);
  }
}


function getCommunicationViewModel(message: CommunicationAPIModel): CommunicationViewModel
{
  return {
    Key: messageKey,
    MessageType: MessageType.Communication,
    CommunicationType: CommunicationType[message.CommunicationType as keyof typeof CommunicationType],
    Timestamp: DateTime.fromISO(message.Timestamp).toLocal(),
    AutobedrijfID: message.AutobedrijfID,
    SourceService: message.SourceService,
    SourceID: message.SourceID,

    Email: !message.Email ? undefined : {
      // Note: dit kan zonder mapping omdat de interfaces compatible zijn. TypeScript magic baby!
      // Zodra er echter iets wijzigt krijg je vanzelf een compiler error en moet je alsnog zelf mappen.
      Recipients: message.Email.Recipients,
      Sender: message.Email.Sender,
      Subject: message.Email.Subject, 
      Html: message.Email.Html,
      Attachments: message.Email.Attachments
    },

    SMS: !message.SMS ? undefined : {
      FromName: message.SMS.FromName,
      To: message.SMS.To,
      Body: message.SMS.Body
    }
  };
}


function getMailEventViewModel(message: MailEventAPIModel): MailEventViewModel
{
  return {
    Key: messageKey,
    MessageType: MessageType.MailEvent,
    MailEventType: MailEventType[message.MailEventType as keyof typeof MailEventType],
    Timestamp: DateTime.fromISO(message.Timestamp).toLocal(),
    AutobedrijfID: message.AutobedrijfID,
    SourceService: message.SourceService,
    SourceID: message.SourceID,
    Url: message.Url
  };
}

function selectMessage(message: WebSocketMessageViewModel)
{
  selected.value = message;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)('messageList')), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass(["statusIcon", { connected: websocketConnected.value }]),
          viewBox: "0 0 16 16"
        }, _hoisted_6, 2)),
        _createTextVNode(" " + _toDisplayString((websocketConnected.value ? _unref(t)('status.connected') : _unref(t)('status.disconnected') )), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["message", { selected: selected.value === message }]),
            key: message.Key,
            onClick: ($event: any) => (selectMessage(message))
          }, [
            (isEmail(message))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-envelope",
                    class: "icon"
                  }),
                  _createElementVNode("span", _hoisted_10, _toDisplayString((<CommunicationViewModel>message).Timestamp.toLocaleString(_unref(DateTime).DATETIME_MED_WITH_SECONDS)), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString((<CommunicationViewModel>message).Email!.Subject), 1),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(((<CommunicationViewModel>message).Email!.Recipients.length > 0 ? (<CommunicationViewModel>message).Email!.Recipients[0].Email : '')), 1)
                ], 64))
              : _createCommentVNode("", true),
            (isSMS(message))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-comment-sms",
                    class: "icon"
                  }),
                  _createElementVNode("span", _hoisted_13, _toDisplayString((<CommunicationViewModel>message).Timestamp.toLocaleString(_unref(DateTime).DATETIME_MED_WITH_SECONDS)), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString((<CommunicationViewModel>message).SMS!.FromName), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString((<CommunicationViewModel>message).SMS!.To), 1)
                ], 64))
              : _createCommentVNode("", true),
            (isMailEvent(message))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-bolt",
                    class: "icon"
                  }),
                  _createElementVNode("span", _hoisted_16, _toDisplayString((<MailEventViewModel>message).Timestamp.toLocaleString(_unref(DateTime).DATETIME_MED_WITH_SECONDS)), 1),
                  _createElementVNode("span", _hoisted_17, "Event: " + _toDisplayString(_unref(MailEventType)[(<MailEventViewModel>message).MailEventType]), 1),
                  _createElementVNode("span", _hoisted_18, _toDisplayString((<MailEventViewModel>message).SourceID), 1)
                ], 64))
              : _createCommentVNode("", true)
          ], 10, _hoisted_9))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_19, [
        (isEmail(selected.value))
          ? (_openBlock(), _createBlock(EmailPreview, {
              key: 0,
              message: <CommunicationViewModel>selected.value!
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        (isSMS(selected.value))
          ? (_openBlock(), _createBlock(SMSPreview, {
              key: 1,
              message: <CommunicationViewModel>selected.value!
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        (_unref(isEmptySelection))
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Selecteer een bericht "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})